/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_auth_please_wait = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please wait…`)
};

const es_auth_please_wait = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por favor espera…`)
};

const de_auth_please_wait = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte warten…`)
};

const nl_auth_please_wait = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Even geduld…`)
};

const fr_auth_please_wait = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veuillez patienter…`)
};

const it_auth_please_wait = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attendere prego…`)
};

const pt_br2_auth_please_wait = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aguarde…`)
};

const pt_auth_please_wait = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aguarde…`)
};

const ja_auth_please_wait = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`お待ちください…`)
};

const zh_auth_please_wait = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请稍候…`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const auth_please_wait = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.auth_please_wait(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("auth_please_wait", locale)
	if (locale === "en") return en_auth_please_wait(inputs)
	if (locale === "es") return es_auth_please_wait(inputs)
	if (locale === "de") return de_auth_please_wait(inputs)
	if (locale === "nl") return nl_auth_please_wait(inputs)
	if (locale === "fr") return fr_auth_please_wait(inputs)
	if (locale === "it") return it_auth_please_wait(inputs)
	if (locale === "pt-BR") return pt_br2_auth_please_wait(inputs)
	if (locale === "pt") return pt_auth_please_wait(inputs)
	if (locale === "ja") return ja_auth_please_wait(inputs)
	return zh_auth_please_wait(inputs)
};